import { ConnectionPositionPair, Overlay } from "@angular/cdk/overlay";
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    Inject,
    Injector,
    OnInit,
} from "@angular/core";
import { Subject, take } from "rxjs";
import { USER_SELECT_PARAMS } from "../user-select/user-select.component";
@Component({
    selector: "app-users-dropdown",
    templateUrl: "./users-dropdown.component.html",
    styleUrls: ["./users-dropdown.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersDropdownComponent implements OnInit {
    @HostListener("document:click", ["$event"]) clickedOutside() {
        if (!this.elRef.nativeElement.contains(event.target)) {
            this.modalData.close$.next();
        }
    }

    destroy$ = new Subject<void>();
    constructor(
        private overlay: Overlay,
        private injector: Injector,
        @Inject(USER_SELECT_PARAMS) public modalData: any,
        private elRef: ElementRef
    ) {}
    ngOnInit(): void {}

    getInitials(name: string) {
        const parsedName = name.split(/\s+/);
        if (!parsedName.length) {
            return "";
        }
        if (parsedName.length > 1) {
            return `${parsedName[0].charAt(0).toUpperCase()}${parsedName[1]
                .charAt(0)
                .toUpperCase()}`;
        }
        return `${parsedName[0].charAt(0).toUpperCase()}`;
    }

    select(id: string) {
        const isSelected = this.modalData;
        if (isSelected) {
            this.modalData.select(id, true);

            return;
        }
        this.modalData.select(id, false);
    }
}
